import * as actionTypes from '../../../../models/actionTypes';
import { AutoSuggestResult, AutoSuggestResultV2 } from '../../../../models/apiModels';

export const fetchAutoSuggest = (query: string) => {
  return {
    type: actionTypes.FETCH_AUTOSUGGEST,
    query,
  };
};

export const fetchAutoSuggestV2 = (query: string) => {
  return {
    type: actionTypes.FETCH_AUTOSUGGEST_V2,
    query,
  };
};

export const setAutoSuggestResult = (
  autoSuggestResults: AutoSuggestResult[]
) => {
  return {
    type: actionTypes.SET_AUTOSUGGEST_RESULT,
    autoSuggestResults,
  };
};

export const setAutoSuggestResultV2 = (
  autoSuggestResultsV2: AutoSuggestResultV2
) => {
  return {
    type: actionTypes.SET_AUTOSUGGEST_RESULT_V2,
    autoSuggestResultsV2,
  };
};

export const showAutoSuggest = () => {
  return {
    type: actionTypes.TOGGLE_AUTOSUGGEST,
    isAutoSuggestHidden: false,
  };
};

export const hideAutoSuggest = () => {
  return {
    type: actionTypes.TOGGLE_AUTOSUGGEST,
    isAutoSuggestHidden: true,
  };
};

export const setOriginalQuery = (originalQuery: string) => {
  return {
    type: actionTypes.SET_ORIGINAL_QUERY,
    originalQuery,
  };
};

export const setAutoSuggestFocusedIndex = (
  autoSuggestFocusedIndex: number
) => {
  return {
    type: actionTypes.SET_AUTOSUGGEST_FOCUSED_INDEX,
    autoSuggestFocusedIndex,
  };
};
